module.exports = __webpack_public_path__ + "img/tip.d0bde0a6.png";